module.exports = __webpack_public_path__ + "img/lacteos.9a855806.svg";